import Cookies from 'js-cookie'

const cookieHeader = 'YYZN-'

export function getCookie (key) {
  return Cookies.get(cookieHeader + key)
}

// 保存用户信息
export function setCookie () {
  Cookies.set(cookieHeader + 'name', 'admin')
  return
}
// 删除用户信息
export function removeCookie () {
  Cookies.remove(cookieHeader + 'name')
  return
}
